const numeral = require('numeral');

export default function formatNumber(value: any, format: string = '0,0') {
    return numeral(value).format(format);
}

